/**
 * Print size constants with dimensions and labels
 * Shared enum values between platform-api, fiesta, and live-gallery
 *
 * Usage: PRINT_SIZES[template.printSize] to get { label, width, height, ... }
 */
export const PRINT_SIZES = {
  size2x6: {
    label: '2×6',
    value: 'size2x6',
    width: 600, // Width and height assume portrait orientation
    height: 1800,
  },
  sizeSingle2x6: {
    label: '2×6',
    value: 'sizeSingle2x6',
    width: 600, // Width and height assume portrait orientation
    height: 1800,
  },
  size4x6: {
    label: '4×6',
    value: 'size4x6',
    width: 1200, // Width and height assume portrait orientation
    height: 1800,
  },
  // eslint-disable-next-line camelcase
  size4_5x6: {
    label: '4.5×6',
    value: 'size4_5x6',
    width: 1350, // Width and height assume portrait orientation
    height: 1800,
  },
  size6x6: {
    label: '6×6',
    value: 'size6x6',
    width: 1800, // Width and height assume portrait orientation
    height: 1800,
  },
  size9x16: {
    label: '9×16',
    value: 'size9x16',
    width: 1080,
    height: 1920,
  },
};

/**
 * Get friendly label for a print size value
 * @param {string} printSize - e.g., "size4x6"
 * @returns {string} - e.g., "4×6"
 */
export const getPrintSizeLabel = (printSize) => {
  return PRINT_SIZES[printSize]?.label || printSize;
};
